import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import FooterNavList from '../FooterNavList/FooterNavList';
import type { FooterNavbarItem } from '../Footer/Footer';

interface Props {
    items: FooterNavbarItem[];
}
function FooterNav({ items }: Props): JSX.Element {
    const { t } = useTranslation();

    return (
        <>
            {items.map(item => {
                return (
                    <div
                        key={`footer-column-${item.id}`}
                        className="footer-column"
                    >
                        <h3 className="footer-column__title">
                            {t(`footer.footerNavLinks.${[item.id]}`)}
                        </h3>
                        <ul className="footer-list">
                            <FooterNavList links={item.links} />
                        </ul>
                    </div>
                );
            })}
        </>
    );
}

export default memo(FooterNav);
